import React from "react";
import ProductGrid from "./ProductGrid";
import remedyImage from "../assets/images/remedy.png";
import styles from "../styles/ServiceSection.module.css";

const QuickServices = ({ variant = "cards" }) => {
  return (
    <section className={styles.serviceSection} id="remedy-section">
      <ProductGrid
        serviceId={9}
        title="Remedy Services"
        defaultPageSize={20}
        showPagination={true}
        defaultImage={remedyImage}
        useProductImages={true}  // Product's main image; default image if it has none
        variant={variant}
        viewAllLink={variant === "carousel" ? "/remedy-services" : null}
      />
  
    </section>
  );
};

export default QuickServices;
